import { Button } from '../../../../components/ui/Button/Button';
import S from './LearnDriverMessageStyles';

type Props = {
  title: string;
  onClose: () => void;
};

function LearnDriverMessage({ title, onClose } : Props): JSX.Element {
  return (
    <S.Wrapper>
      <div className="title">
        {title}
      </div>
      <Button
        className="button"
        padding="7px 40px"
        onClick={onClose}
      >OK
      </Button>
    </S.Wrapper>
  );
}

export default LearnDriverMessage;
